<template>
  <v-col v-if="driver">
    <v-flex xs12 pt-1 pb-2>
      <v-layout row align="center">
        <v-flex pt-1 shrink>
          <DriverOptionsBox
            :driver="driver"
            :picture="picture"
            :taxi="taxi"
          ></DriverOptionsBox>
        </v-flex>
        <v-layout row wrap>
          <!-- <v-flex xs12>
            <h3>Rating</h3>
          </v-flex>
          <v-flex xs12 v-if="averageRating != null">
            <span>
              <b>Average:</b>
              {{averageRating}}
            </span>
          </v-flex>
          <v-flex xs12>
            <span>
              <b>Current:</b>
              {{driver.current_rating}}
            </span>
          </v-flex>-->
          <!-- <v-flex xs12>
            <a :href="'/ratings?driverID=' + driver.id">View Reviews</a>
          </v-flex>-->
        </v-layout>
        <v-flex>
          <v-row justify="end" align="start">
            
            <a href="javascript:void(0)" @click="showChatResetDialog = true">
              <h4 class="driverNavigation">Reset Chat</h4>
            </a>
            <a @click="showResetPassword = true">
              <h4 class="driverNavigation">Reset Password</h4>
            </a>
            <router-link
              class="driverNavigation"
              v-if="driver != null"
              :to="`../../invoices/driver/${driver.id}`"
            >
              <h4>Invoices</h4>
            </router-link>
            <!-- <router-link to="/taxis">
                <h4>Documents</h4>
            </router-link>-->
            <router-link
              class="driverNavigation"
              :to="`/driver/edit/${driver.id}`"
            >
              <h4>Update Details</h4>
            </router-link>
            <router-link
              class="driverNavigation"
              :to="`/driver/vehicle_photos/${driver.id}`"
            >
              <h4>Vehicle Photos</h4>
            </router-link>
            <router-link
              class="driverNavigation"
              v-if="driver.taxi != null"
              :to="`/taxi/edit/${driver.taxi.id}`"
            >
              <h4>Update Taxi ({{ driver.taxi.registration_number }})</h4>
            </router-link>
          </v-row>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex pb-2>
      <v-divider />
    </v-flex>
    <v-flex v-if="driverBreakdown != null">
      <v-row class="flex-nowrap" v-if="driverBreakdown != null">
        <v-flex xs4 pr-2>
          <v-row justify="start">
            <v-col>
              <v-row>
                <h5>Invoices</h5>
                <v-spacer />
                <router-link
                  style="fontsize: 13px; fontweight: 400 !important"
                  v-if="driver != null"
                  :to="`../../invoices/driver/${driver.id}`"
                >
                  <p>View Invoices</p>
                </router-link>
              </v-row>
              <table class="tbl">
                <thead class="tbl">
                  <th>ID</th>
                  <th>Cash</th>
                  <th>Card</th>
                  <th>Account</th>
                  <th>Extra</th>
                  <th>Service&nbsp;Fee</th>
                  <th>Payable</th>
                  <th>Status</th>
                </thead>
                <tbody class="tbl">
                  <tr v-for="ij in driverBreakdown.recentInvoices">
                    <td>{{ ij.id }}</td>
                    <td>{{ (ij.cash / 100).toFixed(2) }}</td>
                    <td>{{ (ij.card / 100).toFixed(2) }}</td>
                    <td>{{ (ij.account / 100).toFixed(2) }}</td>
                    <td>{{ (ij.extras / 100).toFixed(2) }}</td>
                    <td>{{ (ij.serviceFee / 100).toFixed(2) }}</td>
                    <td>{{ (ij.payable / 100).toFixed(2) }}</td>
                    <td>
                      {{
                        ij.paid ? "Paid" : ij.processed ? "Unpaid" : "Active"
                      }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </v-col>
          </v-row>
        </v-flex>
        <v-flex px-2>
          <v-divider vertical />
        </v-flex>
        <v-flex xs="auto" pl-2>
          <v-row justify="start">
            <v-col>
              <h5>Recent Bookings</h5>
              <table style="width: 100%" class="tbl">
                <thead class="tbl">
                  <th>ID</th>
                  <th>Date</th>
                  <th>Pickup</th>
                  <th>Destination</th>
                  <th>Cost</th>
                  <th>PT</th>
                </thead>
                <tbody class="tbl">
                  <tr v-for="ij in driverBreakdown.recentTrips">
                    <td>
                      <a @click="goToBooking(ij.booking.id)">{{
                        ij.booking.id
                      }}</a>
                    </td>
                    <td>{{ ij.booking.pickup_time }}</td>
                    <td>{{ ij.booking.pickup_location.description }}</td>
                    <td>
                      {{
                        ij.booking.destinations != null
                          ? ij.booking.destinations[0].description
                          : ""
                      }}
                    </td>
                    <td>{{ (ij.booking.final_cost / 100).toFixed(2) }}</td>
                    <td>{{ ij.booking.payment_type }}</td>
                  </tr>
                </tbody>
              </table>
            </v-col>
          </v-row>
        </v-flex>
      </v-row>
    </v-flex>
    <v-flex py-3>
      <v-divider />
    </v-flex>
    <v-flex xs="auto" pl-2>
      <v-row justify="start">
        <v-flex pr-2>
          <v-col>
            <v-row align="center" justify="between">
              <h5 style="padding-right: 64px">Ratings</h5>
              <v-spacer></v-spacer>
              <p style="fontsize: 13px">
                <a target="_blank" :href="'/ratings?driverID=' + driver.id"
                  >All Ratings</a
                >
              </p>
            </v-row>
            <table xxclass="tbl">
              <thead class="tbl">
                <th>Current</th>
                <th>Average</th>
              </thead>
              <tbody class="tbl">
                <tr>
                  <td>{{ driver.current_rating }}</td>
                  <td>{{ driver.averageRating }}</td>
                </tr>
              </tbody>
            </table>
            <v-flex pt-2>
              <table style="width: 100%" class="tbl">
                <thead class="tbl">
                  <th>Booking</th>
                  <th>Customer</th>
                  <th>Content</th>
                  <th>Rating</th>
                </thead>
                <tbody class="tbl">
                  <tr v-for="review in driverBreakdown.recentReviews">
                    <td>
                      <a @click="goToBooking(review.booking_id)">{{
                        review.booking_id
                      }}</a>
                    </td>
                    <td>
                      <a @click="goToBooking(review.customer_id)">{{
                        review.customer_name
                      }}</a>
                    </td>
                    <td>{{ review.description }}}</td>
                    <td>
                      <v-rating
                        dense
                        small
                        v-model="review.rating"
                        readonly
                      ></v-rating>
                    </td>
                  </tr>
                </tbody>
              </table>
            </v-flex>
          </v-col>
        </v-flex>
        <v-divider vertical />
        <v-flex pr-2>
          <DriverPermissions :driver="driver"/>
        </v-flex>
      </v-row>
    </v-flex>
    <v-flex py-2>
      <v-divider />
    </v-flex>
    <v-flex>
      <v-row>
        <v-flex md12 lg6 pl-2>
          <h5>Timesheet</h5>
          <v-flex pt-3>
            <Timesheet :driver="driver"></Timesheet>
          </v-flex>
        </v-flex>
        <v-flex>
          <v-divider />
        </v-flex>
        <v-flex md12 lg6 pl-2>
          <h5>Planner</h5>
          <v-flex pt-3>
            <Planner :driverPlanner="driverBreakdown.driverPlanner"></Planner>
          </v-flex>
        </v-flex>
      </v-row>
    </v-flex>
    <v-flex v-if="driver != null">
      <v-row>
        <v-flex md12 pl-2>
          <h5>No Matches</h5>
          <v-flex pt-3>
            <NoMatchPanel :driver="driver"></NoMatchPanel>
          </v-flex>
        </v-flex>
      </v-row>
    </v-flex>
    <ResetPassword
      :show="showResetPassword"
      :userID="driver.user.id"
      :userName="driver.user.name"
      @hideResetPassword="showResetPassword = false"
    />
  
    <v-dialog
      v-model="showChatResetDialog"
      width="500"
    >
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Reset Driver Chat
          <v-spacer></v-spacer>
          <v-icon @click="showChatResetDialog = false">mdi-close</v-icon>
        </v-card-title>
      
        <v-card-text class="mt-4">
          Are you sure you want to reset Driver's Chat? This will delete all conversation history.
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="resetDriverChat"
          >
            I accept
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-col>
</template>

<script>
import SimpleCard from "@/components/widget/SimpleCard.vue";
import DriverList from "@/components/driver/DriverList.vue";
import Timesheet from "@/components/driver/Timesheet.vue";
import Planner from "@/components/driver/Planner.vue";
import DriverOptionsBox from "@/components/driver/DriverOptionsBox.vue";
import ResetPassword from "@/components/customer/ResetPassword.vue";
import NoMatchPanel from "@/components/nomatch/NoMatchPanel.vue";
import DriverPermissions from "@/components/driver/DriverPermissions.vue";

import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  name: "driver",
  components: {
    SimpleCard,
    DriverList,
    DriverOptionsBox,
    Timesheet,
    ResetPassword,
    Planner,
    NoMatchPanel,
    DriverPermissions
  },
  props: {
    driver: Object,
  },
  data: function () {
    return {
      picture: null,
      councils: null,
      loading: true,
      averageRating: null,
      showResetPassword: false,
      driverBreakdown: null,
      showChatResetDialog: false,
      permissions: null
    };
  },
  mounted: async function () {
    this.getDriverBreakdown();
  },
  methods: {
    async resetDriverChat() {
      try {
        this.$loadingDialog.show()
        var url = `${this.$store.state.apiUrl}/driver/reset_chat/${this.driver.id}`;
        let response = await axios.get(url, {
          params: {},
        });
        this.$loadingDialog.hide()
        this.$snackbar.success('Driver chat reset successfully')
        this.showChatResetDialog = false
      } catch (error) {
        this.$loadingDialog.hide()
        this.$snackbar.error('There was a problem in resetting chat.')
        this.showChatResetDialog = false
        console.log("Failed to get driver " + error);
      }
    },
    failed: function (data) {
      alert("Request Failed with error: " + data.error);
    },
    getDriverBreakdown: async function () {
      try {
        var url = `${this.$store.state.apiUrl}/driver/getBreakdownSummaries?driver_id=${this.driver.id}`;

        let response = await axios.get(url, {
          params: {},
        });

        this.driverBreakdown = response.data;

        this.loadingDriver = false;
      } catch (error) {
        this.loadingDriver = false;
        console.log("Failed to get driver " + error);
      }
    },
    goToBooking: function (bookingID) {
      let routeData = this.$router.resolve({
        path: "/bookings",
        query: { bookingID: bookingID },
      });
      window.open(routeData.href, "_blank");
    }
  },
};
</script>

<style  lang="scss">
h4 {
}

.driverNavigation {
  padding-left: 12px;
  padding-right: 12px;
  color: #999fb8 !important;
}

.tbl {
  font-size: 11px;
  color: #292f33 !important;
}
</style>